var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerBi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "i5e5111-mask0_56017_40862",
    width: 30,
    height: 40,
    x: 9,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.667 5.667c0-.92.746-1.667 1.666-1.667h10C38.253 4 39 4.746 39 5.667v36.665c0 .92-.746 1.667-1.667 1.667H10.667c-.92 0-1.667-.746-1.667-1.667V25.666c0-.92.747-1.666 1.667-1.666h6.667v-8.334c0-.92.746-1.666 1.666-1.666h6.667z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#i5e5111-mask0_56017_40862)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i5e5111-paint0_linear_56017_40862)",
    d: "M39 4v39.999H25.667V4z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#i5e5111-filter0_dd_56017_40862)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i5e5111-paint1_linear_56017_40862)",
    d: "M30.667 15.666V44H17.334v-30H29c.92 0 1.667.747 1.667 1.667"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i5e5111-paint2_linear_56017_40862)",
    d: "M9 24v19.999h13.334V25.666c0-.92-.747-1.666-1.667-1.666z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "i5e5111-filter0_dd_56017_40862",
    width: 19.999,
    height: 36.666,
    x: 14.001,
    y: 11.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.158
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_56017_40862"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.833
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_56017_40862",
    result: "effect2_dropShadow_56017_40862"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_56017_40862",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i5e5111-paint0_linear_56017_40862",
    x1: 23.445,
    x2: 41.027,
    y1: 4,
    y2: 41.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6AD10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87E0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i5e5111-paint1_linear_56017_40862",
    x1: 17.333,
    x2: 32.119,
    y1: 14,
    y2: 42.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6AD10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i5e5111-paint2_linear_56017_40862",
    x1: 8.999,
    x2: 17.17,
    y1: 24,
    y2: 43.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6D751"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerBi);
export default __webpack_public_path__ + "static/media/power-bi.c9b1462fc31b544e30136b2dbaeb1b9f.svg";
export { ForwardRef as ReactComponent };